export const redirectToTest = (
  domain: string = 'ege.sdamgia.ru',
  id: number
) => {
  window.location.assign(`/test?id=${id}`)
}
